import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFacebookIconSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="facebook-icon-small_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 35 35"
    {...props}
  >
    <defs>
      <style>{'.facebook-icon-small_svg__cls-1{isolation:isolate}'}</style>
    </defs>
    <g
      id="facebook-icon-small_svg__facebook"
      className="facebook-icon-small_svg__cls-1"
    >
      <path
        d="M647.922 528.23a1.93 1.93 0 0 1-1.93 1.93h-8.922v-13.548h4.547l.68-5.28h-5.234v-3.376c0-1.531.421-2.57 2.617-2.57h2.797v-4.726a38 38 0 0 0-4.079-.211c-4.03 0-6.796 2.46-6.796 6.984v3.899h-4.563v5.28h4.563v13.555h-16.75a1.934 1.934 0 0 1-1.93-1.93v-31.14a1.934 1.934 0 0 1 1.93-1.93h31.132a1.936 1.936 0 0 1 1.938 1.93Z"
        className="facebook-icon-small_svg__cls-1"
        style={{
          fill: '#3b5998',
        }}
        transform="translate(-612.922 -495.167)"
      />
    </g>
  </svg>
);
export default SvgFacebookIconSmall;
